const siteUrl =
	import.meta.env.VITE_SITE_URL ||
	import.meta.env.VITE_BETTER_AUTH_URL ||
	"http://localhost:3000";

type JsonLdValue =
	| string
	| number
	| boolean
	| null
	| JsonLdValue[]
	| { [key: string]: JsonLdValue };

export type JsonLdObject = { [key: string]: JsonLdValue };

export function organizationSchema(): JsonLdObject {
	return {
		"@context": "https://schema.org",
		"@type": "Organization",
		name: "AgentMRR",
		url: siteUrl,
		logo: `${siteUrl}/logo-512.png`,
		sameAs: [
			"https://github.com/thijssmudde/agentmrr",
			"https://x.com/agentmrr",
		],
	};
}

export function websiteSchema(): JsonLdObject {
	return {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: "AgentMRR",
		url: siteUrl,
		publisher: { "@type": "Organization", name: "AgentMRR" },
		potentialAction: {
			"@type": "SearchAction",
			target: {
				"@type": "EntryPoint",
				urlTemplate: `${siteUrl}/?q={search_term_string}`,
			},
			"query-input": "required name=search_term_string",
		},
	};
}

export function articleSchema(opts: {
	title: string;
	description: string;
	path: string;
	image?: string;
	datePublished: string;
	dateModified?: string;
}): JsonLdObject {
	return {
		"@context": "https://schema.org",
		"@type": "TechArticle",
		headline: opts.title,
		description: opts.description,
		mainEntityOfPage: `${siteUrl}${opts.path}`,
		image: opts.image ?? `${siteUrl}/og/default.png`,
		datePublished: opts.datePublished,
		dateModified: opts.dateModified ?? opts.datePublished,
		author: { "@type": "Organization", name: "AgentMRR", url: siteUrl },
		publisher: {
			"@type": "Organization",
			name: "AgentMRR",
			logo: {
				"@type": "ImageObject",
				url: `${siteUrl}/logo-512.png`,
			},
		},
	};
}

export function breadcrumbListSchema(
	items: Array<{ name: string; path: string }>,
): JsonLdObject {
	return {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: items.map((item, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: item.name,
			item: `${siteUrl}${item.path}`,
		})),
	};
}

export function profilePageSchema(opts: {
	name: string;
	description: string;
	path: string;
	image?: string;
}): JsonLdObject {
	const schema: JsonLdObject = {
		"@context": "https://schema.org",
		"@type": "ProfilePage",
		url: `${siteUrl}${opts.path}`,
		name: opts.name,
		description: opts.description,
	};
	if (opts.image) {
		schema.image = opts.image;
	}
	return schema;
}
